const Priority = {
    'Low': 0,
    'Medium': 1,
    'High': 2,
    'Instant': 3,
}
Object.freeze(Priority)

/**
 * This is the model for Schedule.
 * It is used in the Schedule (step 3 for job)
 * page.
 */
class Schedule {
    /**
     * This is a default constructor for Schedule
     * @param {string} id
     * @param {string} quoteId
     * @param {string} signIds
     * @param {string} shortDescription
     * @param {string} longDescription
     * @param {[{thickness: string, material: string}]} materials
     * @param {string} equip
     * @param {string} process
     * @param {number} priority
     * @param {string} assignTo
     * @param {number} orderIndex
     * @param {[string]} dependency
     * @param {boolean} isComplete
     */
    constructor(
        id='', quoteId='', signIds=[], shortDescription='',
        longDescription='',
        materials=[], equip='', process='',
        priority=1, assignTo='', orderIndex=0, isComplete=false,
        dependency=[],
        prematureRelease = false,
        humanExpectedDurationMinutes=0,
    ) {
        this.id = id
        this.quote_id = quoteId
        this.sign_ids = signIds
        this.short_description = shortDescription
        this.long_description = longDescription
        this.materials = materials
        this.equip = equip
        this.process = process
        this.priority = priority
        this.assign_to = assignTo
        this.order_index = orderIndex
        this.is_complete = isComplete
        this.dependency = dependency
        this.premature_release = prematureRelease
        this.human_expected_duration_minutes = humanExpectedDurationMinutes
        this.start_time = null
        this.end_time = null
    }

    /**
     * Create a new Schedule from json
     * @param {json} json
     * @return {Schedule}
     */
    static from(json) {
        const schedule = Object.assign(new Schedule(), json)
        schedule['dependency'] = JSON.parse(JSON.stringify(schedule['dependency']))
        return schedule
    }

    /**
     * Copies Schedule object
     * @return {Schedule}
     */
    copy() {
        return Schedule.from(this)
    }

    /**
     * Sets priority
     * @param {number/string} priority
     */
    setPriority(priority) {
        if (typeof priority === typeof 0) {
            this.priority = priority
        } else if (typeof priority === typeof '') {
            this.priority = Priority[priority]
        } else {
            console.log('Error setting priority to schedule ' +
                'object with value: ' + priority)
        }
    }

    /**
     * @return {string} priority as string
     */
    getPriorityString() {
        for (const [key, value] of Object.entries(Priority)) {
            if (value === this.priority) {
                return key
            }
        }
        console.log('Error could not find priority with value: ' +
            this.priority)
        return ''
    }

    /**
     * @param {integer} id
     */
    addDependency(id) {
        if (this.dependency.indexOf(id) < 0) {
            this.dependency.push(id)
        }
    }

    /**
     * @param {integer} id
     */
    toggleDependency(id) {
        if (this.dependency.indexOf(id) < 0) {
            this.dependency.push(id)
        } else {
            this.dependency = this.dependency.filter((x) => x !== id)
        }
    }

    /**
     * @param {UUIID} id
     * @return {boolean}
     */
    hasDependency(id) {
        return this.dependency.indexOf(id) >= 0
    }

    /**
     * @param {Schedule} task
     * @return {boolean}
     */
    canMerge(task) {
        return this.short_description === task.short_description &&
            this.long_description === task.long_description &&
            this.equip === task.equip &&
            this.process === task.process &&
            this.assign_to === task.assign_to &&
            this.is_complete === task.is_complete
    }
}

module.exports = {
    Schedule,
    Priority,
}

